import React from 'react';
import PropTypes from 'prop-types';

import VersionCard from '@components/asset/modal/tabs/workflow/attachment_details/versions_sidebar/version_card';
import VersionPreview from '@components/asset/modal/tabs/workflow/attachment_details/versions_sidebar/version_preview';
import Toggle from '@components/common/toggle/main';

import './styles/main.scss';

const VersionsSidebar = (props) => {
  const {
    activeCard,
    activeVersion,
    annotationMode,
    activeAttachmentReservations,
    commentsFeatureEnabled,
    initializeTab,
    setActiveVersion,
    setAnnotationMode,
    setAnnotationsResponse,
    setAttachmentReservations,
    setAttachments,
    setShowCheckinCheckout,
    setTempAnnotation,
    setVersionsActionLoading,
    versionCard,
    versionCards,
    updateFetchControllers,
    users,
  } = props;

  const latestVersionId = !versionCards ? null : versionCards.find((card) => (card.type === 'version')).id;
  const toggleSizes = {
    height: 16,
    width: 32,
    sliderDiameter: 12,
  };

  const handleToggle = (e) => {
    e.preventDefault();
    setAnnotationMode((prevState) => (!prevState));
  };

  return (
    <section className="versions-sidebar">
      <div className="version-preview">
        <VersionPreview
          activeVersion={activeVersion}
          versionCard={versionCard}
        />
      </div>
      {commentsFeatureEnabled && (
        <div className="sidebar-header">
          <div className="annotation-mode-container">
            <button
              className="toggle-wrapper"
              onClick={handleToggle}
              type="button"
            >
              <Toggle
                sizes={toggleSizes}
                isOn={annotationMode}
              />
            </button>
            <h4>{t('Create and view annotations')}</h4>
          </div>
        </div>
      )}
      <ul className="sidebar-content">
        <li className="sidebar-title">{t('Version Timeline')}</li>
        {activeVersion && Boolean(versionCards) && users
          && versionCards.map((sidebarCard) => (
            <VersionCard
              key={sidebarCard.id}
              activeCard={activeCard}
              activeVersion={activeVersion}
              annotationMode={annotationMode}
              checkedInStatus={activeAttachmentReservations.currentStatus}
              commentsFeatureEnabled={commentsFeatureEnabled}
              initializeTab={initializeTab}
              isLatestVersion={sidebarCard.id === latestVersionId}
              setActiveVersion={setActiveVersion}
              setAnnotationsResponse={setAnnotationsResponse}
              setAttachmentReservations={setAttachmentReservations}
              setAttachments={setAttachments}
              setShowCheckinCheckout={setShowCheckinCheckout}
              setTempAnnotation={setTempAnnotation}
              setVersionsActionLoading={setVersionsActionLoading}
              sidebarCard={sidebarCard}
              updateFetchControllers={updateFetchControllers}
              users={users}
            />
          ))
        }
      </ul>
    </section>
  );
};

VersionsSidebar.propTypes = {
  activeCard: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.oneOf(['asset', 'attachment']),
  }).isRequired,
  activeVersion: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  annotationMode: PropTypes.bool.isRequired,
  activeAttachmentReservations: PropTypes.shape({
    currentStatus: PropTypes.string,
  }).isRequired,
  commentsFeatureEnabled: PropTypes.bool.isRequired,
  initializeTab: PropTypes.func.isRequired,
  setActiveVersion: PropTypes.func.isRequired,
  setAnnotationMode: PropTypes.func.isRequired,
  setAnnotationsResponse: PropTypes.func.isRequired,
  setAttachmentReservations: PropTypes.func.isRequired,
  setAttachments: PropTypes.func.isRequired,
  setShowCheckinCheckout: PropTypes.func.isRequired,
  setTempAnnotation: PropTypes.func.isRequired,
  setVersionsActionLoading: PropTypes.func.isRequired,
  versionCard: PropTypes.shape({}).isRequired,
  versionCards: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['reservation', 'version'])
  })).isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
  users: PropTypes.shape({}).isRequired,
};

export default VersionsSidebar;
